import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from 'api/models';
export const dateSorter = (a, b)=>{
    if (a == null) {
        return -1;
    }
    if (b == null) {
        return 1;
    }
    return moment(a, DEFAULT_DATE_FORMAT).diff(moment(b, DEFAULT_DATE_FORMAT), 'days');
};
export const numberSorter = (a, b)=>{
    if (a == null) {
        return -1;
    }
    if (b == null) {
        return 1;
    }
    return a - b;
};
